import { graphql, useStaticQuery } from 'gatsby';

const getPosts = (posts) => posts.edges.map((edge) => edge.node);

const usePestControlBlogPosts = () => {
  const { allContentfulBlog } = useStaticQuery(graphql`
    {
      allContentfulBlog(
        filter: { seo: { taxonomy: { industries: { in: "Pest Control" } } } }
        sort: { publishDate: DESC }
        limit: 3
      ) {
        edges {
          node {
            ...BlogCardFeatured
          }
        }
      }
    }
  `);

  return getPosts(allContentfulBlog);
};

export default usePestControlBlogPosts;
